import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de2347a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-grow tw-text-left tw-mr-4" }
const _hoisted_2 = {
  key: 0,
  class: "tw-absolute tw-top-[-8px] tw-left-[-8px] lg:tw-left-[-35px]"
}
const _hoisted_3 = { class: "tw-relative tw-top-0 tw-left-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-absolute tw-top-[13px] lg:tw-top-[25px] tw-w-[50px] lg:tw-w-[70px] tw-text-center tw-text-mainbg1 tw-text-[10px] lg:tw-text-[14px] tw-font-bold" }, " FREE ", -1))
const _hoisted_5 = { class: "rule-name tw-mb-2" }
const _hoisted_6 = {
  key: 1,
  class: "tw-mb-2"
}
const _hoisted_7 = { class: "tw-grid tw-grid-cols-2 tw-text-left lg:tw-flex lg:tw-justify-end" }
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FreeBadgeSvg = _resolveComponent("FreeBadgeSvg")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["tw-relative tw-top-0 tw-left-0 tw-mb-6 lg:tw-mb-12 tw-py-1 tw-rounded-lg tw-pl-12 lg:tw-pl-16 tw-pr-2 rule-item", _ctx.mainClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showFreeBadge)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_FreeBadgeSvg, { class: "free-badge tw-w-[50px] tw-h-[50px] lg:tw-w-[70px] lg:tw-h-[70px]" }),
              _hoisted_4
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.rule.spellingRuleName), 1),
      (_ctx.hasScores)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.rule.resultResume?.attemptCount) + " Attempts. Best Score: " + _toDisplayString(_ctx.bestScore) + ". Last Score: " + _toDisplayString(_ctx.lastScore), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          href: "",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.runAction('play')), ["prevent"])),
          class: "rule-link"
        }, " Play ")
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          href: "",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.runAction('wordList')), ["prevent"])),
          class: "rule-link"
        }, " View Words ")
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          href: "",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.runAction('print')), ["prevent"])),
          class: "rule-link"
        }, " Printables ")
      ]),
      (_ctx.hasScores)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("a", {
              href: "",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.runAction('results')), ["prevent"])),
              class: "rule-link"
            }, " View Score Details ")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}